import React from 'react';
import MaterialTable, { MTableToolbar } from "material-table";
import { useHistory } from 'react-router-dom';
import './datagrid.styles.scss';

const DataGrid = ({ title, isClickable, columns, data }) => {
  const options = {
    pageSize: 10
  }

  let his = useHistory();
  // const title = title;
  // const isClickable = isClickable;

  let table = <MaterialTable title={title} columns={columns} data={data} options={options} />

  if (isClickable) {
    table = <MaterialTable columns={columns} data={data} options={options} onRowClick={(e, rowData) => {
      // if (isState) {
      //   his.push(`/details/${rowData.parentId}/${rowData.id}`)
      // } else {
      his.push(`/details/${rowData.countryInfo.iso2}`);
      // }
    }}
      components={{
        Toolbar: props => {
          return (<div>
            <MTableToolbar {...props} title={title} />
            <div className={isClickable ? 'alert' : 'no--alert'}>
              Click on row for details
          </div>
          </div >)
        }
      }}
    />
  }
  return (
    <React.Fragment>
      {table}
    </React.Fragment>
  );
}

export default DataGrid;